<template>
  <div class="MineBox">
		<Nav />
    <div class="mine">
			<div class="_cont">
				<div class="_left">
					<div class="_info">
						<div class="_top">
							<img class="_Tx" src="../assets/infos.png" alt="">
							<p class="_phone" v-if="infoData">{{infoData.name ? infoData.name : infoData.phone ? infoData.phone : '暂无'}}</p>
						</div>
						<div class="_bot">
							<p @click.stop="active_Li(5)">修改密码</p>
							<p @click.stop="outLog()">退出登录</p>
						</div>
					</div>
					<div class="_list">
						<p
						v-for="(item, index) in left_list"
						:key="index" 
						@click.stop="active_Li(index)"
						:class="'_li ' + [activeLi == index ? '_active' : '']" >
							<img class="_img" :src="item.img" alt="">
							<span>{{item.name}}</span>
						</p>
					</div>
				</div>
				<div class="_right">
					<Infos v-if="activeLi == 0" />
					<Certificat v-if="activeLi == 1" />
					<Record v-if="activeLi == 2" />
					<Consumption v-if="activeLi == 3" />
					<Modify :phone="infoData.phone" v-if="activeLi == 5" />
				</div>
			</div>
		</div>
		<Foot />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { WOW } from 'wowjs' 
import Foot from '@/components/Foot.vue'
import Infos from './_mine/_info.vue'
import Certificat from './_mine/_certificat.vue'
import Modify from './_mine/_Modify.vue'
import Record from './_mine/_record.vue'
import Consumption from './_mine/_consumption.vue'
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
export default {
	name: 'topUp',
  components: {
    Nav,
		Foot,
		Infos,
		Certificat,
		Record,
		Consumption,
		Modify
	},
	
	data(){
		return {
			left_list:[
				{img:require('../assets/gerenshezhi.png'),name:'账户信息'},
				{img:require('../assets/qyrz.png'),name:'实名认证'},
				{img:require('../assets/chongzhi.png'),name:'消费充值'},
				{img:require('../assets/xiaofeijilu.png'),name:'我的套餐'},
			],
			activeLi:'0',
			infoData:null,
		}
	},
	computed:{
		activeLiShow(){
			return this.$store.state.MineActiveLi
		},
		mineData(){
			return this.$store.state.mineData
		}
	},
	watch:{
		'mineData':{
			handler(value){
				if(value){
					this.infoData = value 
				}else{
					this.getInfoData()
				}
			},
			immediate: true,
			deep: true 
		},
		'activeLiShow':{
			handler(value){
				this.activeLi = value ? value : 0
			},
			immediate: true,
			deep: true 
		}
	},
	created(){
		
	},
	methods:{
		active_Li(index){
			this.activeLi = index
			
			if(index !== 5){
				this.$store.commit("setMineActiveLi", index);
			}
		},
		getInfoData(){
			let access_token = localStorage.getItem('access_token')
			let data = {
				access_token:access_token
			}
			request({
				method: 'get', 
				url: Apis.readMemberInfo,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.infoData = res.data
					this.$store.commit("setMineData", res.data);
				}else{
					this.$message.error(res.msg);
				}
			});
		},
		outLog(){
			let data = {
				access_token:localStorage.getItem('access_token')
			}
			request({
				method: 'post', 
				url: Apis.logout,
				params:data
			}).then(res => {
				localStorage.removeItem('name');
				localStorage.removeItem('access_token');
				localStorage.removeItem('id');
				localStorage.removeItem('username');
				localStorage.removeItem('userpass');
				this.$store.commit("access_token", null);
				// 重置登录框标志
				const { resetLoginFlag } = require('@/router/index.js')
				resetLoginFlag()
				// 跳转到首页并刷新
				this.$router.push('/')
				setTimeout(() => {
					window.location.reload()
				}, 100)
			});
		}
	}
}
</script>

<style lang="less" scoped>
.MineBox{
	width: 100%;
	.mine{
		background: #f9f9f9;
		width: 100%;
		._cont{
			width: 1200px;
			margin: 0 auto;
			display: flex;
			
			._left{
				width: 260px;
				min-height: 880px;
				background: #1F8EFF;
				margin-top: 22px;
				margin-bottom: 22px;
				._info{
					width: 100%;
						// height: 248px;
						padding: 10px;
					._top{
						width: 100%;
						height: 56px;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-top: 54px;
						._Tx{
							width: 56px;
							height: 56px;
							border-radius: 50%;
							overflow: hidden;
							background-color: #fff;
						}
						._phone{
							font-size: 18px;
							color: #fff;
							font-weight: bolder;
							margin-left: 10px;
						}
					}
					._bot{
						width: 100%;
						display: flex;
						justify-content: space-around;
						margin-top: 27px;
						p{
							width: 100px;
							height: 40px;
							border-radius: 6px;
							background: #fff;
							line-height: 40px;
							font-size: 16px;
							color: #1F8EFF;
							cursor: pointer;
						}
					}
				}
				._list{
					width: 100%;
					margin-top: 60px;
					._li{
						width: 100%;
						height: 80px;
						display: flex;
						justify-content: center;
						align-items: center;
						line-height: 80px;
						font-size: 18px;
						cursor:pointer;
						._img{
							width: 24px;
							height: 24px;
						}
						span{
							margin-left: 5px;
							color: #fff;
						}
					}
					._active{
						background: #1171D4;
					}
				}
			}
			._right{
				width: calc(100% - 280px);
				margin-left: 20px;
				min-height: 880px;
				margin-top: 22px;
				margin-bottom: 22px;
				// background: #fff;
			}
		}
	}
}

</style>